

<app-loader></app-loader>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="custom-sidenav" [@sidenavWidth]="sidenavAnimationState" [class.collapsed]="sidenavAnimationState === 'collapsed'" [class.expanded]="sidenavAnimationState === 'expanded'" [attr.role]="'navigation'"
    [mode]="isHandset ? 'over' : 'side'" [opened]="isHandset ? sideNavOpened : true" (mouseenter)="expandSidenav()" (mouseleave)="collapseSidenav()">
    <div class="sidenav-header" [@sidenavHeader]="sidenavAnimationState">
      <h3 class="sidenav-title" [@sidenavTitle]="sidenavAnimationState">{{ appSvc.shortTitle }}</h3>
    </div>
    <div class="sidenav-content">
      <div class="nav-item" style="margin-bottom: 20px;">
        <a class="nav-link" (click)="showingMenuAdd = !showingMenuAdd">
          <mat-icon class="nav-icon">add</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Nuevo...</span>
        </a>
        <div *ngIf="showingMenuAdd" class="submenu">
          <a class="nav-link" routerLink="/solicitudes/new" (click)="closeSideNavIfHandset(drawer)">Solicitud</a>
          <a class="nav-link" (click)="closeSideNavIfHandset(drawer); openFileDialog()">Fichero de solicitudes</a>
          <a class="nav-link" (click)="closeSideNavIfHandset(drawer); createPartida()">Partida</a>
          <a class="nav-link" routerLink="/clientes" [queryParams]="{ nuevo: true }" (click)="closeSideNavIfHandset(drawer)">Cliente</a>
          <a class="nav-link" routerLink="/productos" [queryParams]="{ nuevo: true }" (click)="closeSideNavIfHandset(drawer)">Producto</a>
          <a class="nav-link" (click)="closeSideNavIfHandset(drawer); receiveProduct()">Recepción de material</a>
        </div>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/main" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">home</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Inicio</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/usuarios-admin" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">person</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Usuarios</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/clientes" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">group</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Clientes</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/productos" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">local_offer</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Productos</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/dashboard" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">bar_chart</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Dashboard</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/consultas" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">pageview</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Consultas</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/almacen" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">receipt</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Almacén</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/reports" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">list_alt</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Informes</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/devoluciones" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">assignment_return</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Devoluciones</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/facturacion" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">monetization_on</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Facturación</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/pagos" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">payments</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Pagos</span>
        </a>
      </div>
      <div class="nav-item">
        <a class="nav-link" routerLink="/almacenes" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">receipt</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">Almacenes</span>
        </a>
      </div>
      
      <div class="nav-item">
        <a class="nav-link" routerLink="/ws-externos" (click)="closeSideNavIfHandset(drawer)" routerLinkActive="nav-link-active">
          <mat-icon class="nav-icon">cast</mat-icon>
          <span class="nav-text" [@sidenavText]="sidenavAnimationState">WS Externos</span>
        </a>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="main-toolbar">
      <button *ngIf="isHandset" type="button" aria-label="Toggle sidenav" mat-icon-button (click)="toggleSideNav()" class="menu-button">
        <mat-icon>menu</mat-icon>
      </button>
      <img class="title" routerLink="/main" src="/assets/images/logo-topbar.png" />
      <span class="toolbar-title">{{ appSvc.appSubTitle }}</span>
      <div class="toolbar-spacer"></div>
      <form #formSearch [formGroup]="fSearch" class="search-form">
        <div class="search-wrapper">
          <input matInput type="text" formControlName="search" placeholder="Buscar..." class="search-input">
          <button mat-icon-button (click)="globalSearch()" class="search-button">
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </form>
      <button mat-icon-button aria-label="logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
      </button>
    </mat-toolbar>
    <div class="main-content" [class.no-padding]="isNoPaddingRoute">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- <div class="router-content login-content" *ngIf="isLoginRoute">
  <router-outlet></router-outlet>
</div> -->
